const MOBILE_MIN = 320;
const MOBILE_MAX = 480;
export const TABLET_MIN = 768;
const TABLET_MAX = 1024;
const DESKTOP = 1224;
const DESKTOP_LARGE_MIN = 1600;

export const BREAKPOINT_VALUES = {
  MOBILE_MIN,
  MOBILE_MAX,
  TABLET_MIN,
  TABLET_MAX,
  DESKTOP,
  DESKTOP_LARGE_MIN,
};

/**
 * @deprecated use @ordermentum/ui-shared/foundations/grid where possible
 */
export const BREAKPOINTS = {
  MOBILE_MIN: `${MOBILE_MIN}px`,
  MOBILE_MAX: `${MOBILE_MAX}px`,
  TABLET_MIN: `${TABLET_MIN}px`,
  TABLET_MAX: `${TABLET_MAX}px`,
  SHOW_SIDENAV: `${TABLET_MAX}px`,
  DESKTOP: `${DESKTOP}px`,
  DESKTOP_LARGE_MIN: `${DESKTOP_LARGE_MIN}px`,
};
